import { useSelector } from 'react-redux';
import { selectChatObject } from '../model/recentChat/selectors';

export const useChatObject = chatId => {
   return useSelector(selectChatObject(chatId));
};
